import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  readonly rootUrl = environment.apiUrl;
  readonly noAuthHeader = new HttpHeaders({ 'No-Auth': 'True' });
  constructor(private http: HttpClient) { }

  getUserClaims() {
    return this.http.get(this.rootUrl + '/api/GetUserClaims');
}
}
